// extracted by mini-css-extract-plugin
export var bannerBlogContentContainer = "bannerBlog-module--bannerBlogContentContainer--46fa4";
export var bannerBlogCopy = "bannerBlog-module--bannerBlogCopy--71445";
export var bannerBlogText = "bannerBlog-module--bannerBlogText--43aa5";
export var contentContainer = "bannerBlog-module--contentContainer--b501d";
export var image = "bannerBlog-module--image--19d1d";
export var imageContainer = "bannerBlog-module--imageContainer--ad50a";
export var moduleContainer = "bannerBlog-module--moduleContainer--32fc3";